import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { SlideInterfaceModel } from '../../../models/slide.model';

@Component({
  selector: 'app-card-slider',
  templateUrl: './card-slider.component.html',
  styleUrls: ['./card-slider.component.scss'],
  standalone: false,
})
export class CardSliderComponent implements OnDestroy {
  @Input() slides: SlideInterfaceModel[] = [];
  @Input() isLoading = false;
  @Output() cardClicked = new EventEmitter<SlideInterfaceModel>();

  currentIndex: number = 0;
  timeoutId?: number;

  @ViewChild('scrl') scrl: ElementRef | undefined;

  scrollX = 0;
  scrollEnd = false;

  onCardClicked(slide: SlideInterfaceModel) {
    this.cardClicked.emit(slide);
  }

  ngOnDestroy() {
    window.clearTimeout(this.timeoutId);
  }

  goToPrevious(): void {
    const isFirstSlide = this.currentIndex === 0;
    const newIndex = isFirstSlide
      ? this.slides.length - 1
      : this.currentIndex - 1;

    this.currentIndex = newIndex;
  }

  goToNext(): void {
    const isLastSlide = this.currentIndex === this.slides.length - 1;
    const newIndex = isLastSlide ? 0 : this.currentIndex + 1;

    this.currentIndex = newIndex;
  }

  goToSlide(slideIndex: number): void {
    this.currentIndex = slideIndex;
  }

  getCurrentSlideUrl() {
    return `url('${this.slides[this.currentIndex].url}')`;
  }
  getCurrentSlideTitle() {
    return this.slides[this.currentIndex].title;
  }
  getCurrentSlideDetails() {
    return this.slides[this.currentIndex].details;
  }

  slide(shift: number) {
    if (this.scrl) {
      this.scrl.nativeElement.scrollBy({
        left: shift,
        behavior: 'smooth',
      });
      if (this.scrollX <= 4 && shift === -300) {
        shift += this.scrl.nativeElement.scrollWidth;
      } else if (this.scrollEnd && shift === 300) {
        shift -= this.scrl.nativeElement.scrollWidth;
      }
      this.scrl.nativeElement.scrollLeft += shift;
      this.scrollX += shift;

      this.scrollCheck();
    }
  }

  scrollCheck() {
    if (this.scrl) {
      this.scrollX = this.scrl.nativeElement.scrollLeft;
      this.scrollEnd =
        Math.floor(
          this.scrl.nativeElement.scrollWidth -
            this.scrl.nativeElement.scrollLeft
        ) <=
        this.scrl.nativeElement.offsetWidth + 4;
    }
  }
}
